import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'shared-warning',
  imports: [CommonModule, IconComponent],
  templateUrl: './warning.component.html',
  styleUrl: './warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningComponent {
  @Input() headline = 'Notice';
  @Input() buttonLabel: string | undefined;
  @Output() buttonClick = new EventEmitter<void>();
}
